import { render, staticRenderFns } from "./failing.vue?vue&type=template&id=325af0a0&scoped=true&"
import script from "./failing.vue?vue&type=script&lang=js&"
export * from "./failing.vue?vue&type=script&lang=js&"
import style0 from "./failing.vue?vue&type=style&index=0&id=325af0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325af0a0",
  null
  
)

export default component.exports